export function Chat1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.987 7.014A6.5 6.5 0 004 10.5c0 1.01.282 1.99.729 2.888l.104.21v2.569h2.193a8.46 8.46 0 00.507 2.3 8.452 8.452 0 01-.707-.3H2.833v-4.105C2.338 13.003 2 11.795 2 10.5a8.5 8.5 0 0116.468-2.967 8.448 8.448 0 00-2.481-.52z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.142 16.858a6.454 6.454 0 00.87 2.128A6.495 6.495 0 0015.5 22c.983 0 1.917-.219 2.755-.611h3.134V18.17c.363-.791.611-1.697.611-2.671a6.495 6.495 0 00-3.014-5.487l-.002-.041-.018.028a6.467 6.467 0 00-2.108-.858 6.5 6.5 0 00-7.716 7.716zM11 15.5a4.5 4.5 0 119 0c0 .691-.193 1.369-.507 2l-.104.21v1.679h-1.61l-.216.112a4.5 4.5 0 01-6.563-4z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
